/*
 * File: /src/store/modules/callTypeDetails.js
 * Created Date: Monday August 17th 2026
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */
import CallTypeDetailService from 'src/services/callTypeDetailService';

const byLabel = (a, b) => (a.label || '').localeCompare(b.label || '');

const state = {
  callTypeDetails: undefined,
};

const getters = {
  getCallTypeDetails: (state) => (callResultTypeId) => {
    if (!state.callTypeDetails) return [];
    if (callResultTypeId == undefined) return state.callTypeDetails;
    return state.callTypeDetails.filter(
      (ctd) => ctd.call_result_type_id == callResultTypeId
    );
  },
  getCallTypeDetailById: (state) => (id) => {
    if (!state.callTypeDetails) return undefined;
    return state.callTypeDetails.find((ctd) => ctd.id == id);
  },
};

const actions = {
  // Only load the data once
  async fetchCallTypeDetails({ commit, state }) {
    if (state.callTypeDetails == undefined) {
      const res = await CallTypeDetailService.fetchAll();
      commit('setCallTypeDetails', res.data.toSorted(byLabel));
    }
  },
  async reloadCallTypeDetails({ commit }) {
    const res = await CallTypeDetailService.fetchAll();
    commit('setCallTypeDetails', res.data.toSorted(byLabel));
  },
  async createCallTypeDetail({ commit }, payload) {
    const res = await CallTypeDetailService.createCallTypeDetail(payload);
    commit('upsertCallTypeDetail', res.data);
    return res.data;
  },
  async updateCallTypeDetail({ commit }, { id, payload }) {
    const res = await CallTypeDetailService.updateCallTypeDetail(id, payload);
    commit('upsertCallTypeDetail', res.data);
    return res.data;
  },
  async deleteCallTypeDetail({ commit }, id) {
    await CallTypeDetailService.deleteCallTypeDetail(id);
    commit('removeCallTypeDetail', id);
  },
  unloadCallTypeDetails({ commit }) {
    commit('setCallTypeDetails', undefined);
  },
};

const mutations = {
  setCallTypeDetails(state, callTypeDetails) {
    state.callTypeDetails = callTypeDetails;
  },
  upsertCallTypeDetail(state, callTypeDetail) {
    if (state.callTypeDetails == undefined) {
      state.callTypeDetails = [callTypeDetail];
      return;
    }
    const idx = state.callTypeDetails.findIndex(
      (ctd) => ctd.id == callTypeDetail.id
    );
    if (idx >= 0) {
      state.callTypeDetails.splice(idx, 1, callTypeDetail);
    } else {
      state.callTypeDetails.push(callTypeDetail);
    }
    state.callTypeDetails.sort(byLabel);
  },
  removeCallTypeDetail(state, id) {
    if (state.callTypeDetails == undefined) return;
    state.callTypeDetails = state.callTypeDetails.filter(
      (ctd) => ctd.id != id
    );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
